// generateSlug.js
const UrltoSlug = (url) => {
  function toSlug(text = "") {
    return text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove all non-word characters
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start
      .replace(/-+$/, ""); // Trim - from end
  }

  return `${toSlug(url)}`; // Do not change this
};

export default UrltoSlug;
